/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:52 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 40:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 21:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 22:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 24:52 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 34:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 11:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 12:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 12:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 14:52 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 20:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 24:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async() => {
    const { Core } = await importModule('Core');

    customElements.define('main-navigation-mobile', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]'
        }

        render() {
            this._handleNavigation();
        }
        
        _handleNavigation() {
            this.$navItems.map(item => {
                item.addEventListener('click', e => {
                    this.$stage.dataset.current = item.dataset.toLvl;
                })
            })
        }
    });

})()